export default function useTaskDueDatePicker() {
  const shortcuts = [
    {
      text: "Today",
      value: new Date(),
    },
    {
      text: "Tomorrow",
      value: () => {
        const date = new Date();
        date.setDate(date.getDate() + 1);
        return date;
      },
    },
    {
      text: "A Week Later",
      value: () => {
        const date = new Date();
        date.setDate(date.getDate() + 7);
        return date;
      },
    },
  ];

  const disabledDate = (time: Date) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const currentDay = currentDate.getDate();

    const year = time.getFullYear();
    const month = time.getMonth();
    const day = time.getDate();

    const currentTimeOnly = new Date(currentYear, currentMonth, currentDay);
    const timeOnly = new Date(year, month, day);

    return timeOnly.getTime() < currentTimeOnly.getTime();
  };

  return {
    shortcuts,
    disabledDate,
  };
}
